module.exports = __webpack_public_path__ + "static/img/mall_tab_icon_4_2.2c1297e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mall/mall_tab_icon_4_2.png
// module id = CfnX
// module chunks = 0